import { useEffect, useState } from 'react'

export const useExternalScript = () => {
  const [scriptLoaded, setScriptLoaded] = useState(false)

  useEffect(() => {
    const script = document.createElement('script')
    script.type = 'module'
    script.src = '/assets/js/index.js'
    script.crossOrigin = ''
    script.async = true

    script.onload = () => {
      window.updateContent?.()
      setScriptLoaded(true)
    }

    document.head.appendChild(script)

    return () => {
      document.head.removeChild(script)
    }
  }, [])

  return scriptLoaded
}